/**
 * Where a document's party lives, as a route.
 *
 * Which of the two routes is used is NOT cosmetic. `PartyDetailPage` reads the
 * path to decide where "back" goes and which list it belongs to
 * (`/purchasing/suppliers` vs `/sales/parties`), because a party can be both a
 * customer and a supplier and only the way you arrived says which hat it is
 * wearing. Send a bill's supplier to the customers route and the page offers to
 * take them back to a list they are not on.
 *
 * Payments are why this is a function rather than a map keyed on the endpoint:
 * one list holds customer receipts and supplier payments together, and the only
 * thing that tells them apart is the row's own `direction`.
 *
 * A new purchase-side document type belongs in `PURCHASE_ENDPOINTS`. Getting
 * that wrong costs a wrong back-link, not a wrong party — the id is the id
 * either way — so this deliberately guesses "customer" rather than hiding the
 * link for anything it does not recognise.
 */
const PURCHASE_ENDPOINTS = new Set(['/bills', '/purchase-orders', '/debit-notes']);

export function partyPath(endpoint: string, partyId: string, direction?: string | null): string {
  const isPurchase = PURCHASE_ENDPOINTS.has(endpoint) || direction === 'outbound';
  return `${isPurchase ? '/purchasing/suppliers' : '/sales/parties'}/${partyId}`;
}
